module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA3.1bf666ef.jpg";